const AUTH_BASE_URL = (process.env.REACT_APP_LOGIN_URL || 'https://login.hostul.com.br').replace(/\/+$/, '');
const CART_BASE_URL = (process.env.REACT_APP_CART_URL || 'https://carrinho.hostul.com.br').replace(/\/+$/, '');
const PANEL_BASE_URL = (process.env.REACT_APP_PANEL_URL || 'https://painel.hostul.com.br').replace(/\/+$/, '');
const API_BASE_URL = (process.env.REACT_APP_API_URL || 'https://api.hostul.com.br').replace(/\/+$/, '');
const SUPPORT_API_BASE_URL = (
  process.env.REACT_APP_SUPPORT_API_URL || 'https://api-suporte.hostul.com.br'
).replace(/\/+$/, '');

export const EXTERNAL_URLS = {
  authBase: AUTH_BASE_URL,
  register: `${AUTH_BASE_URL}/cadastro`,
  cartBase: CART_BASE_URL,
  panelBase: PANEL_BASE_URL,
  apiBase: API_BASE_URL,
  supportApiBase: SUPPORT_API_BASE_URL,
};
